module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step3_Image24.d8e3140c.jpg";